var inputStyles = {
  root: function root(_ref) {
    var p = _ref.props;
    return Object.assign({
      alignItems: 'center',
      display: 'inline-flex',
      position: 'relative',
      outline: 0
    }, p.fluid && {
      width: '100%'
    });
  },
  input: function input(_ref2) {
    var p = _ref2.props,
        v = _ref2.variables;
    return Object.assign({
      backgroundColor: v.backgroundColor
    }, p.inverted && {
      backgroundColor: v.backgroundColorInverted
    }, {
      lineHeight: 'unset',
      color: v.fontColor,
      borderColor: v.borderColor,
      borderRadius: v.borderRadius,
      borderStyle: 'solid',
      borderWidth: v.borderWidth,
      outline: 0,
      padding: v.inputPadding,
      position: 'relative'
    }, p.fluid && {
      width: '100%'
    }, {}, p.inline && {
      "float": 'left'
    }, {
      '::placeholder': {
        color: v.placeholderColor,
        opacity: 1 // undo Firefox default opacity

      },
      ':focus': {
        borderColor: v.inputFocusBorderColor
      }
    }, p.clearable && {
      padding: v.inputPaddingWithIconAtEnd
    }, {}, p.icon && {
      padding: p.iconPosition === 'start' ? v.inputPaddingWithIconAtStart : v.inputPaddingWithIconAtEnd
    });
  },
  icon: function icon(_ref3) {
    var p = _ref3.props,
        v = _ref3.variables;
    return Object.assign({
      color: v.iconColor,
      outline: 0,
      position: v.iconPosition
    }, p.iconPosition === 'start' && {
      left: v.iconLeft
    }, {}, p.iconPosition === 'end' && {
      right: v.iconRight
    });
  }
};
export default inputStyles;